import * as actions from '~/actions/formActions/kitchenDepartmentSelection'
import { cloneDeep } from 'lodash'
import { createReducer } from '~/helpers/reduxHelper';

const selectAllKitchen = (kitchenDepartment, checked) => {
  kitchenDepartment.map((d)=>d.checked=!checked)
}

const selectKitchen = (kitchenDepartment, id,checked) => {
  kitchenDepartment.filter((d)=>d.id===id).map((d)=>d.checked=checked)
}

const findSelectedDeep = (kitchenDepartments = []) => {
  let selected = [];
  (kitchenDepartments || []).forEach(d=> {
    if (d.checked) {
      selected.push(d);
    }
  })
  return selected;
}

const initialState = {
  isOpen :false,
  all: [],
  selected: [],
  params: null,
  items:[],
}

const actionHandlers = {
  [actions.GET_ALL_KITCHEN_DEPARTMENTS]:(state, action) => {
    const { payload } = action;
    state.all = payload;
    return Object.assign({}, state)
  },
  [actions.OPEN_KITCHEN_DEPARTMENT_SELECTION]: (state, action) => {
    const { all, params } = action;
    let allItems = all.map(d => ({
      id: d.id,
      kitchen_department_id: d.id,
      kitchen_department_name: d.name,
      checkbox: true,
      checked:false,
    }))
    return Object.assign({}, state, { isOpen: true, all: allItems ,params })
  },

  [actions.TOGGLE_KITCHEN_DEPARTMENT_SELECTION]: (state, action) => {
    const { checked,id } = action;
    let { all } = state;
    all = cloneDeep(all);
    selectKitchen(all,id,checked)
    const selected = findSelectedDeep(all);
    return Object.assign({}, state, { all, selected });
  },

  [actions.TOGGLE_ALL_KITCHEN_DEPARTMENT_SELECTION]: (state, action) => {
    const { checked } = action;
    let { all } = state;
    all = cloneDeep(all);
    selectAllKitchen(all,checked)
    const selected = findSelectedDeep(all);
    return Object.assign({}, state, { all, selected });
  },

  [actions.CLOSE_KITCHEN_DEPARTMENT_SELECTION]: () => initialState,
  [actions.SAVE_KITCHEN_DEPARTMENT_SELECTION]: () => initialState,

}

export default createReducer(initialState, actionHandlers);



/** WEBPACK FOOTER **
 ** ./client/store/reducers/formsReducer/kitchenDepartmentSelection.js
 **/